import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HealthService {
  apiBaseUrl = environment.apiBaseUrl.replace(/api\//, '');

  constructor(
    private readonly http: HttpClient) { }

  live() {
    return this.http.get(
      `${this.apiBaseUrl}health/live`,
      { responseType: 'text' as const }
    );
  }

  ready() {
    return this.http.get(
      `${this.apiBaseUrl}health/ready`,
      { responseType: 'text' as const }
    );
  }
}
